/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Menu, MenuItem, Select, SelectChangeEvent, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TableComponent from '../../../components/TableComponent';
import { Listing } from '../../../types/General';
import { SOLD_STATUS, UPDATE_TYPES, VEHICLE_TYPE } from '../../../utils/enums';

type props = {
  rows: Listing[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  setUsers?: any;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  handleSoldChange: (e: SelectChangeEvent<string>, id: string) => void;
  // handleDeleteUser: () => void;
  setModalType: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleUserUpdate: any;
};

const ApprovedIndividualListings = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
  setUsers,
  selectedId,
  setSelectedId,
  setModalType,
  setOpen,
  handleSoldChange,
  handleUserUpdate,
}: props) => {
  const navigate = useNavigate();

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const [soldStatus, setSoldStatus] = useState<keyof typeof SOLD_STATUS>('PENDING');

  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  // console.log(soldStatus, "soldStatus");

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.6,
      minWidth: 250,
      field: 'vehicle',
      headerName: 'Vehicle Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            <figure
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${row?._id}`)}
            >
              <img src={row?.coverImage || '/static/images/picture.png'} alt="Vehicle" />
            </figure>
            <p>
              <b>{row?.title || '-'}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>
                {row?.vehicleType === VEHICLE_TYPE.CAR
                  ? 'Car'
                  : row?.vehicleType === VEHICLE_TYPE.BIKE
                    ? 'Bike'
                    : row?.vehicleType === VEHICLE_TYPE.TRUCK
                      ? 'Truck'
                      : row?.vehicleType === VEHICLE_TYPE.HEAVY_VEHICLE
                        ? 'Heavy Vehicle'
                        : '- -'}
              </b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Seller Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.userImage || '/static/images/user_placeholder.png'} alt="User" />
            </figure>
            <p>
              <b>{row?.name || '-'}</b> {row?.dialCode} {row?.phoneNo || '-'}
              <br />
              {row?.email || '-'}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: 'soldStatus',
      filterable: false,
      sortable: false,
      headerName: 'Sold Status',
      renderCell: ({ row }) => {
        return (
          <Select
            value={SOLD_STATUS[row?.soldStatus]}
            // value={SOLD_STATUS[row?.soldStatus]}
            onChange={(e) => {
              handleSoldChange(e, row?._id);
            }}
            disabled={row?.soldStatus === 1}
            variant="outlined"
            size="small"
            sx={{
              borderRadius: '8px',
              backgroundColor: '#fff',
              boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
              minWidth: 120,
            }}
          >
            <MenuItem disabled value={SOLD_STATUS[1]}>
              Pending
            </MenuItem>
            <MenuItem disabled value={SOLD_STATUS[2]}>
              Seller marked
            </MenuItem>
            <MenuItem value={SOLD_STATUS[3]}>Approved</MenuItem>
            <MenuItem value={SOLD_STATUS[4]}>Rejected</MenuItem>
          </Select>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isBlocked}
            onChange={() => handleUserUpdate(row?._id, !row?.isBlocked, UPDATE_TYPES.BLOCK)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'premimStatus',
      filterable: false,
      sortable: false,
      headerName: 'Premium Listing',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isPremiumCar}
            onChange={() =>
              handleUserUpdate(row?._id, !row?.isPremiumCar, UPDATE_TYPES.ADD_TO_PREMIUM)
            }
          />
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row?._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${selectedId}`)}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate(`/listings/edit/${selectedId}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl1(null);
                    setModalType('delete');
                    setOpen(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const hidden = ['fullName'];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default ApprovedIndividualListings;
